// @flow
import 'rxjs';
import { combineEpics } from 'redux-observable';
import { epics as authEpics } from './auth/actions';
import { epics as usersEpics } from './users/actions';

const epics = [...authEpics, ...usersEpics];

const configureEpics = (deps: Object) => (action$: any, { getState }: any) =>
  combineEpics(...epics)(action$, { ...deps, getState });

export default configureEpics;
